import { Skeleton } from 'antd'

const TableSkeleton = () => (
  <div aria-busy="true" aria-label="Loading list">
    <Skeleton active paragraph={{ rows: 8 }} />
  </div>
)

export default TableSkeleton
